module.exports = __webpack_public_path__ + "assets/ico-clone.5b0bf08a.svg";